<template>
	<input class="string-view" type="text" @input="$emit('update:modelValue', $event.target.value, $event)" :value="modelValue" />
</template>

<script>
	export default {
		name: 'string-view',
		props: ['modelValue'],
		emits: ['update:modelValue']
	}
</script>

<style lang="scss" scoped>
	.string-view {
		height: 30px;
		padding: 0 10px 0 10px;
	}
</style>